import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Typography, Box, IconButton, Drawer, color, TextArea, Button } from '@kistech/kis-ui';
import { useActions } from 'hooks/useActions';
import { selectors as configSelectors, actions as configActions, Configuration } from 'store/configurations';

interface LinkedContentDrawerProps {
  isOpen: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attractLoop: any;
  configuration: Configuration;
  onClose: () => void;
}

export const LinkedContentDrawer: React.FC<LinkedContentDrawerProps> = (props: LinkedContentDrawerProps) => {
  const { isOpen, onClose, attractLoop, configuration } = props;
  const { pending, error, success } = useSelector(configSelectors.selectAction);
  const [updateConfiguration, resetAction, resetError] = useActions([
    configActions.updateConfiguration,
    configActions.resetAction,
    configActions.resetError
  ]);
  const [linkedContentUrl, setLinkedContentUrl] = useState(attractLoop && attractLoop.linkedContentUrl);

  useEffect(() => {
    if (!isOpen) {
      setLinkedContentUrl('');
      if (error) {
        resetError();
      }
    } else {
      setLinkedContentUrl(attractLoop && attractLoop.linkedContentUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (success && isOpen) {
      resetAction();
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleSave = () => {
    const { globalSettings } = configuration.configuration;
    updateConfiguration({
      id: configuration.id,
      configuration: {
        ...configuration.configuration,
        globalSettings: { ...globalSettings, attractLoop: { ...attractLoop, linkedContentUrl } }
      }
    });
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} hasBorderRadius>
      <Flex direction="column" padding="6 0" width={500} bg="white">
        <Flex align="center" justify="between" padding="0 6">
          <Typography size={32} weight={600}>
            Linked Content
          </Typography>
          <IconButton
            name="exit_circle"
            appearance="transparent"
            size={40}
            onClick={onClose}
            data-testid="update-image-x"
          />
        </Flex>

        <Box flexOverride="none" fullWidth height={1} margin="6 0" style={{ backgroundColor: color.X_LIGHT_GRAY }} />
        <Box margin="0 6" width={400}>
          <Typography size={22} style={{ marginLeft: '20px', textAlign: 'center' }}>
            URL
          </Typography>
          <TextArea
            placeholder="http://example.com"
            fullWidth
            size="medium"
            value={linkedContentUrl}
            onChange={(e) => {
              setLinkedContentUrl(e.target.value);
              if (error) resetError();
            }}
            autoFocus
          />
        </Box>
        <Box margin="4 6" width={430} style={{ textAlign: 'center' }}>
          <Box margin="0 3">
            {error && (
              <Box margin="2 0">
                <Typography color={color.RED}>{error}</Typography>
              </Box>
            )}
            <Button appearance="primary" size="small" width={200} onClick={handleSave} isLoading={pending}>
              Save
            </Button>
          </Box>
        </Box>
      </Flex>
    </Drawer>
  );
};
